import React from "react";

const sectors = [
  {
    icon: (
      <svg width="48" height="48" fill="none" viewBox="0 0 48 48"><rect width="48" height="48" rx="8" fill="none"/><path d="M10 36V18l8-4 8 4v18" stroke="#222" strokeWidth="2" strokeLinejoin="round"/><path d="M18 14V36" stroke="#222" strokeWidth="2" strokeLinejoin="round"/><rect x="28" y="22" width="10" height="14" rx="1" fill="#222"/><rect x="30.5" y="25" width="2" height="2" rx="1" fill="#fff"/><rect x="35.5" y="25" width="2" height="2" rx="1" fill="#fff"/><rect x="30.5" y="29" width="2" height="2" rx="1" fill="#fff"/><rect x="35.5" y="29" width="2" height="2" rx="1" fill="#fff"/></svg>
    ),
    title: "Real Estate",
    description:
      "Innovative MEP solutions to elevate real estate projects, focusing on sustainability and modern design to meet the dynamic needs of the property market.",
  },
  {
    icon: (
      <svg width="48" height="48" fill="none" viewBox="0 0 48 48"><rect width="48" height="48" rx="8" fill="none"/><path d="M12 36V22l12-8 12 8v14" stroke="#222" strokeWidth="2" strokeLinejoin="round"/><rect x="18" y="28" width="4" height="4" rx="1" fill="#222"/><rect x="26" y="28" width="4" height="4" rx="1" fill="#222"/><rect x="22" y="32" width="4" height="4" rx="1" fill="#222"/></svg>
    ),
    title: "Education Sector",
    description:
      "Empower educational institutions with MEP solutions designed for the modern learning environment. We provide sustainable, efficient systems to support schools and universities, creating optimal conditions for students and staff.",
  },
  {
    icon: (
      <svg width="48" height="48" fill="none" viewBox="0 0 48 48"><rect width="48" height="48" rx="8" fill="none"/><rect x="14" y="18" width="20" height="16" rx="2" stroke="#222" strokeWidth="2"/><rect x="20" y="24" width="8" height="6" rx="1" fill="#222"/><rect x="22" y="26" width="4" height="2" rx="1" fill="#fff"/><rect x="18" y="20" width="4" height="2" rx="1" fill="#222"/><rect x="26" y="20" width="4" height="2" rx="1" fill="#222"/></svg>
    ),
    title: "Health Care",
    description:
      "Empower educational institutions with MEP solutions designed for the modern learning environment. We provide sustainable, efficient systems to support schools and universities, creating optimal conditions for students and staff.",
  },
  {
    icon: (
      <svg width="48" height="48" fill="none" viewBox="0 0 48 48"><rect width="48" height="48" rx="8" fill="none"/><rect x="14" y="18" width="20" height="16" rx="2" stroke="#222" strokeWidth="2"/><rect x="20" y="24" width="8" height="6" rx="1" fill="#222"/><rect x="22" y="26" width="4" height="2" rx="1" fill="#fff"/><rect x="18" y="20" width="4" height="2" rx="1" fill="#222"/><rect x="26" y="20" width="4" height="2" rx="1" fill="#222"/></svg>
    ),
    title: "Hospitality",
    description:
      "Tailored MEP solutions for the hospitality industry, enhancing guest experiences through cutting-edge technology and energy-efficient design. Elevate your hotel or resort with our innovative services.",
  },
];

const Expertise = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-12">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2 flex items-center">
          Expertise Across Sectors
        </h2>
        <div className="w-24 h-1 bg-red-600 rounded mb-8" />
        <p className="text-gray-700 text-base md:text-lg mb-8 leading-relaxed">
          At Milestone Associates, we extend our expertise across various pivotal sectors including real estate, healthcare, education, and data centers. Our dedicated team crafts solutions that cater to the unique demands of each industry, ensuring optimal performance and reliability.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {sectors.map((sector, idx) => (
            <div key={idx} className="bg-gray-100 rounded-lg p-8 flex flex-col md:flex-row items-start gap-6 shadow-sm">
              <div className="flex-shrink-0">{sector.icon}</div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{sector.title}</h3>
                <p className="text-gray-600 text-base leading-relaxed">{sector.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Expertise; 